const DashboardTypes = {
    SummaryDashbaord : 'Summary Dashbaord',
    MainDashboard : 'Main Dashboard',
    DayDashboard : 'Day Dashboard',
    RevenueCollectorDashbaord : 'Revenue Collector Dashbaord',
}

export default DashboardTypes